import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '@core/service';
import { ArrayUtilities } from '@shared/utility';
import { atLeastOneInputHasValue } from '@mynexus/mynexus-ui-lib';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-aspire-info-form',
  templateUrl: './aspire-info-form.component.html',
  styleUrls: ['./aspire-info-form.component.scss'],
  standalone: false
})
export class AspireInfoFormComponent implements OnInit {
  aspireStatuses$: Observable<SelectItem[]>;
  aspireStagingStatuses$: Observable<SelectItem[]>;
  aspireDischargeReasons$: Observable<SelectItem[]>;

  form: FormGroup;

  constructor(
    private lookupService: LookupService,
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getLookups();
  }

  onClose(): void {
    if (this.form.touched && this.form.dirty) {
      this.confirmationService.confirm({
        header: `Cancel ${this.config.header.replace(' New', '')}`,
        key: 'aspireCancelConfirmation',
        accept: () => {
          this.dialogRef.close(null);
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  onSave(): void {
    this.dialogRef.close(this.form.value);
  }

  onPalliativePerformanceScaleInput(event) {
    event.target.value = event.target.value.slice(0, 3);
  }

  private createForm(): void {
    this.form = new FormGroup(
      {
        referred: new FormControl(false),
        referredDate: new FormControl(),
        enrolled: new FormControl(false),
        enrolledDate: new FormControl(),
        status: new FormControl(),
        stagingStatus: new FormControl(),
        mostRecentAssessmentDate: new FormControl(),
        primaryDiagnosis: new FormControl(),
        dischargeDate: new FormControl(),
        dischargeReason: new FormControl(),
        palliativePerformanceScale: new FormControl(null, [
          Validators.min(0),
          Validators.max(100),
          Validators.pattern(/^\d*$/),
        ]),
      },
      atLeastOneInputHasValue()
    );

    if (this.config.data) {
      this.form.patchValue(this.config.data);
    }
  }

  private getLookups(): void {
    this.aspireStatuses$ = this.lookupService.getAspireStatuses()
      .pipe(map(res =>
        ArrayUtilities.arrayToSelectItemArrayByItem(res.map(({ status }) => status))));

    this.aspireStagingStatuses$ = this.lookupService.getAspireStagingStatuses()
      .pipe(map(res =>
        ArrayUtilities.arrayToSelectItemArrayByItem(res.map(({ aspireStatus }) => aspireStatus))));

    this.aspireDischargeReasons$ = this.lookupService.getAspireDischargeReasons()
      .pipe(
        map(res =>
          ArrayUtilities.arrayToSelectItemArrayByItem(res.map(({ aspireDischargeReason }) => aspireDischargeReason)))
      );
  }
}
